import { render, staticRenderFns } from "./tipTapVuetify.vue?vue&type=template&id=0339d769"
import script from "./tipTapVuetify.vue?vue&type=script&lang=js"
export * from "./tipTapVuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports